export default function  AddButton({...rootDOMAttributes}) {
  return (
    <div {...rootDOMAttributes} className="btn_add flex fixed bottom-20 md:bottom-4 right-4 bg-violet-500 hover:bg-violet-700 text-white p-2 rounded-full justify-center items-center w-fit cursor-pointer z-[100]">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 455 455" height='2rem' width='2rem'>
        <polygon points="455,212.5 242.5,212.5 242.5,0 212.5,0 212.5,212.5 0,212.5 0,242.5 212.5,242.5 212.5,455 242.5,455 242.5,242.5   455,242.5 "/>
      </svg>
    </div>
  )
}
